var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeApplied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.359,
    height: 44,
    viewBox: "0 0 47.359 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.296,
    y1: 0.5,
    x2: 0.84,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.972,
    y1: 0.896,
    x2: -0.18,
    y2: -0.076,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e27f04",
    stopOpacity: 0.039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#c15d2f",
    stopOpacity: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.596,
    x2: 0.5,
    y2: 1.283,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.595,
    y1: 0.863,
    x2: 0.35,
    y2: -0.072,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#dd7a0b",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#c76327",
    stopOpacity: 0.561
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.173,
    y1: 0.087,
    x2: 1.09,
    y2: 1.245,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.523,
    y1: 0.591,
    x2: 0.37,
    y2: -0.552,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#899ab2",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.773,
    y1: 1.579,
    x2: 0.45,
    y2: 0.532,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    stopColor: "#9fb3d5",
    stopOpacity: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#8898af",
    stopOpacity: 0.451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#798898",
    stopOpacity: 0.788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 0.527,
    x2: 0.5,
    y2: 1.216,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.578,
    y1: 0.703,
    x2: 0.226,
    y2: -0.701,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 0.705,
    x2: 0.5,
    y2: 1.116,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#1b1f3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 0.246,
    x2: 0.5,
    y2: 1.172,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fd436f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#f63162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#ec154d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48231",
    "data-name": "Group 48231",
    transform: "translate(-197 -67.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(197 67.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55544",
    "data-name": "Path 55544",
    d: "M59.6,44H27.71a2.687,2.687,0,0,1-2.687-2.687V2.686A2.687,2.687,0,0,1,27.71,0H59.6a2.687,2.687,0,0,1,2.687,2.687V41.313A2.687,2.687,0,0,1,59.6,44Zm0,0",
    transform: "translate(-22.873)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55545",
    "data-name": "Path 55545",
    d: "M81.762,62.655V26.612l-2.4-2.4a2.418,2.418,0,0,0-1.853-.862H48.756a2.424,2.424,0,0,0-2.424,2.423V60.912a2.419,2.419,0,0,0,.862,1.853l2.577,2.577h29.3a2.687,2.687,0,0,0,2.687-2.687Zm0,0",
    transform: "translate(-42.351 -21.341)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55546",
    "data-name": "Path 55546",
    d: "M25.023,402.289v6.742a2.687,2.687,0,0,0,2.687,2.687H59.6a2.687,2.687,0,0,0,2.687-2.687v-6.742Zm0,0",
    transform: "translate(-22.873 -367.717)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55547",
    "data-name": "Path 55547",
    d: "M166.963.54A1.524,1.524,0,0,0,165.8,0H153.4a1.529,1.529,0,0,0-1.529,1.529v2a1.525,1.525,0,0,0,.54,1.166l8.849,8.849a1.525,1.525,0,0,0,1.166.54h12.4a1.529,1.529,0,0,0,1.529-1.529v-2a1.524,1.524,0,0,0-.54-1.166Zm0,0",
    transform: "translate(-138.816 0)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55548",
    "data-name": "Path 55548",
    d: "M77.506,63.335H48.756a2.424,2.424,0,0,1-2.424-2.423V25.771a2.424,2.424,0,0,1,2.424-2.423H77.506a2.424,2.424,0,0,1,2.424,2.423V60.912A2.424,2.424,0,0,1,77.506,63.335Zm0,0",
    transform: "translate(-42.35 -21.342)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55549",
    "data-name": "Path 55549",
    d: "M175.811,30.731l-7.383-7.383H151.867v1.524a1.526,1.526,0,0,0,.541,1.166l8.849,8.849a1.525,1.525,0,0,0,1.166.54h12.4a1.529,1.529,0,0,0,1.529-1.529v-2a1.525,1.525,0,0,0-.54-1.166Zm0,0",
    transform: "translate(-138.816 -21.342)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55550",
    "data-name": "Path 55550",
    d: "M48.756,378.732H77.507a2.424,2.424,0,0,0,2.424-2.423V373.8l-4.612-4.611a2.417,2.417,0,0,0-1.794-.794H46.332v7.911a2.424,2.424,0,0,0,2.424,2.424Zm0,0",
    transform: "translate(-42.351 -336.739)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55551",
    "data-name": "Path 55551",
    d: "M31.174,368.4H2.424A2.423,2.423,0,0,0,0,370.822v3.195a4.716,4.716,0,0,0,4.716,4.716H35.4a1.8,1.8,0,0,1-1.8-1.8v-6.111a2.423,2.423,0,0,0-2.423-2.424Zm0,0",
    transform: "translate(0 -336.739)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48223",
    "data-name": "Group 48223",
    transform: "translate(7.927 15.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55552",
    "data-name": "Path 55552",
    d: "M92.242,176.742h25.707v1.405H92.242Zm0,0",
    transform: "translate(-92.242 -176.742)",
    fill: "#a1b5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55553",
    "data-name": "Path 55553",
    d: "M92.242,241.141h25.707v1.405H92.242Zm0,0",
    transform: "translate(-92.242 -235.607)",
    fill: "#a1b5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55554",
    "data-name": "Path 55554",
    d: "M92.242,305.535h20.471v1.406H92.242Zm0,0",
    transform: "translate(-92.242 -294.467)",
    fill: "#a1b5d8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55555",
    "data-name": "Path 55555",
    d: "M176.351,45.578h-1.406v1.358a1.689,1.689,0,0,1-1.687,1.687H167.1l-2.93-3.045h-1.406v1.358a3.085,3.085,0,0,0,.975,2.251l6.66,6.66a3.083,3.083,0,0,0,2.251.975h7.4a3.1,3.1,0,0,0,3.092-3.092V52.371Zm0,0",
    transform: "translate(-148.777 -41.662)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55556",
    "data-name": "Path 55556",
    d: "M173.259,50.029h-7.4a3.1,3.1,0,0,1-3.092-3.093V45.578h1.406v1.358a1.689,1.689,0,0,0,1.687,1.687h7.4a1.689,1.689,0,0,0,1.687-1.687V45.578h1.406v1.358A3.1,3.1,0,0,1,173.259,50.029Zm0,0",
    transform: "translate(-148.778 -41.662)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55557",
    "data-name": "Path 55557",
    d: "M165.8,5.059H153.4a1.529,1.529,0,0,1-1.529-1.529v-2A1.529,1.529,0,0,1,153.4,0h12.4a1.529,1.529,0,0,1,1.529,1.529v2A1.529,1.529,0,0,1,165.8,5.059Zm0,0",
    transform: "translate(-138.816 0)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55592",
    "data-name": "Path 55592",
    d: "M239.9,231.948A7.948,7.948,0,1,1,231.948,224,7.948,7.948,0,0,1,239.9,231.948Zm0,0",
    transform: "translate(4.463 -128.13)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55593",
    "data-name": "Path 55593",
    d: "M301.286,328.167l-1.711-1.712a.883.883,0,0,1,1.249-1.249l.572.571,4-3.334a.883.883,0,1,1,1.131,1.357Zm0,0",
    transform: "translate(-66.696 -220.946)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeApplied);
export default __webpack_public_path__ + "static/media/home-applied.647429684cbb28056ccadc230a245726.svg";
export { ForwardRef as ReactComponent };